import { AvatarGroup, AvatarGroupProps } from '@chakra-ui/react';

type VAvatarGroupProps = AvatarGroupProps;

const VAvatarGroup = ({ children, ...props }: VAvatarGroupProps) => (
  <AvatarGroup {...props}>{children}</AvatarGroup>
);

export default VAvatarGroup;
export type { VAvatarGroupProps };
